var latest_offer_v2 = {
  // default bundle
  init: function() {
    var product_bundles = $('.product-bundle-v2');

    $('.btn', product_bundles).addClass('btn-secondary');

    product_bundles.each(function() {
      var _this = $(this),
          available = true;
      
      if ($('> .row', _this).length > 0) {
        _this.addClass('product-bundle-v2-col-plus');
      }

      $('.product-bundle-v2-container', _this).each(function() {
        var _this2 = $(this);
        var handle = _this2.data('product'),
            variants = _this2.data('variants') || '',
            image = _this2.data('image') || '';

        $.get(`${Shopify.routes.root}products/${handle}?view=api-html-offer-v2`, function(product_html) {
          if (product_html.indexOf('<html') >= 0) return;
          
          var string_id = Math.random().toString(36).substring(2,7);
          product_html = product_html.replaceAll('[string_id]', string_id);
          _this2.html(product_html);

          if (variants != '') {
            variants = variants.split(',');
            var option_skus = [];
            $('select[name="id"] option', _this2).each(function() {
              var option_sku = $(this).attr('data-sku');
              if (variants.indexOf(option_sku) < 0) {
                option_skus.push(option_sku);
              }
            });
            $.each(option_skus, function(i, variant) {
              $(`.product-bundle-v2-img img[data-sku="${variant}"]`, _this2).remove()
                .parent().remove();
              $(`.product-bundle-v2-variants .swatch-element[data-sku="${variant}"]`, _this2).remove();
              $(`select[name="id"] option[data-sku="${variant}"]`, _this2).remove();
            });

            $('select[name="id"] option:first-child', _this2).prop('selected', true);

            // if ($('select[name="id"] option', _this2).length == 1) {
            //   $('.product-bundle-v2-variants', _this2).hide();
            // }
          }
          if ($('select[name="id"] option', _this2).not('[disabled="disabled"]').length == 1) {
            $('.product-bundle-v2-variants', _this2).hide();
          }

          var val = $('select[name="id"]', _this2).val() || $('select[name="id"] > option:first-child', _this2).attr('value'),
              opt = $(`select[name="id"] option[value="${val}"]`, _this2);
          
          if (available) {
            available = opt.attr('data-available');
            if (available == 'false') {
              $('.offer-btn-add-to-cart', _this).text(window.kef.latest_offer_texts.sold_out)
                .attr('disabled', 'disabled')
                .addClass('disabled');
            }
          }
          
          var price_before = $('.product-bundle-v2-price-before .product-bundle-v2-price-value', _this);
          if (price_before.text() == '' && opt.attr('data-price_before') > 0) {
            price_before.text(Shopify.formatMoney(opt.attr('data-price_before'), window.money_format));
          }
          
          var price_after = $('.product-bundle-v2-price-after .product-bundle-v2-price-value', _this);
          if (price_after.text() == '' && opt.attr('data-price_after') > 0) {
            price_after.text(Shopify.formatMoney(opt.attr('data-price_after'), window.money_format));
          }

          var first_img = $(`.product-bundle-v2-img img[data-variant_title="${opt.attr('data-variant_title')}"]`, _this2)
          first_img.addClass('active')
            .parent().addClass('active')
            .siblings().removeClass('active');

          if (image != '') {
            first_img.attr('src', image);
          }
          
          $('.product-bundle-v2-title a', _this2).attr('href', $(`.product-bundle-v2-img a.active`, _this2).attr('href'));

          $('.offer-btn-add-to-cart', _this2).attr('data-add-to-cart', $('.offer-btn-add-to-cart', _this2).text());
        });
      });

      if (available == 'false') {
        $('.offer-btn-add-to-cart', _this).text(window.kef.latest_offer_texts.sold_out)
          .attr('disabled', 'disabled')
          .addClass('disabled');
      } else {
        $('.offer-btn-add-to-cart', _this)
          // .text(window.kef.latest_offer_texts.add_to_cart)
          .removeAttr('disabled')
          .removeClass('disabled');
      }

      _this.addClass('active');
    });

    product_bundles.on('click', function(e) {
      if ($(e.target).closest('.product-swatch-dropdown').length == 0 && $('.product-swatch-dropdown.active').length > 0) {
        $('.product-swatch-dropdown').removeClass('active');
      }
    });
    product_bundles.on('click', '.product-swatch-dropdown', function(e) {
      $(this).toggleClass('active');
    });
    product_bundles.on('change', '.product-swatch-dropdown input', updateVariant);
    product_bundles.on('change', '.product-swatch-dropdown input', function() {
      var dropdown = $(this).parents('.product-swatch-dropdown');
      $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
      dropdown.removeClass('active');
    });

    product_bundles.on('change', '.product-swatch-radio input', updateVariant);

    function updateVariant() {
      // product level
      var product = $(this).parents('.product-bundle-v2-container');
      // bundle level
      var bundle = $(this).parents('.product-bundle-v2');

      var opts = [];
      $('.product-bundle-v2-variants input:checked', product).each(function() {
        opts.push($(this).val());
      });

      var variant_option = $(`.product-variants-dropdown select option[data-variant_title="${opts.join(' / ')}"]`, product);
      $('.product-variants-dropdown select', product).val(variant_option.val());

      var product_img = $(`.product-bundle-v2-img img[data-variant_title="${variant_option.attr('data-variant_title')}"]`, product);
      product_img.addClass('active')
        .parent().addClass('active')
        .siblings().removeClass('active');

      $('.product-bundle-v2-title a', product).attr('href', $(`.product-bundle-v2-img a.active`, product).attr('href'));

      // bundle level
      var available = 'true';
      var price_before = $('.product-bundle-v2-price-before .product-bundle-v2-price-value', bundle);
      var price_after = $('.product-bundle-v2-price-after .product-bundle-v2-price-value', bundle);
      $('.product-variants-dropdown select', bundle).each(function() {
        var selected = $('option:selected', this);

        available = available == 'true' ? selected.attr('data-available') : available;
        
        if (price_before.text() == '') {
          price_before.text(selected.attr('data-price_before'));
        }
        
        if (price_after.text() == '') {
          price_after.text(selected.attr('data-price_after'));
        }
      });

      if (available == 'false') {
        $('.offer-btn-add-to-cart', bundle).text(window.kef.latest_offer_texts.sold_out)
          .attr('disabled', 'disabled')
          .addClass('disabled');
      } else {
        $('.offer-btn-add-to-cart', bundle).text($('.offer-btn-add-to-cart', bundle).attr('data-add-to-cart'))
          .removeAttr('disabled')
          .removeClass('disabled');
      }
    }

    product_bundles.on('click', '.offer-btn-add-to-cart:not(.disabled)', function() {
      var _t = $(this);
      var data = {
        items: []
      };
      var bundle = $(this).parents('.product-bundle-v2');
      $('.product-variants-dropdown select', bundle).each(function() {
        var id = $(this).val();
        var data_item = {
          quantity: 1,
          id: id,
          properties: {}
        }
        var option = $('option[value="'+id+'"]', this);
        var note = option.attr('data-note') || '';
        if (note != '') {
          data_item.properties.note = $(`<div>${note}</div>`).text();
        }
        data.items.push(data_item)
      });

      // product bundle
      var bundle_name = (_t.attr('data-bundle_name') || '').trim();
      if (bundle_name == '') {
        bundle_name = (_t.find('span[data-bundle_name]').attr('data-bundle_name') || '').trim();
      }
      // product bundle

      cart_fn.add(data).done(function(cart) {
        var quantity = data.items.map(function(item, key) {
          return item.quantity;
        });
        $('body').trigger({
          type: 'add_to_cart',
          quantity: quantity,
          cart: cart,
          bundle_name: bundle_name,
        });
      }).fail(function() {
      }).always(function() {
      });
    });
  },

  // multiselect bundle
  initMultiselectall: function() {
    var product_bundles = $('div[class*="product-bundle-multiselectall-v"]');

    $('div[class*="product-bundle-multiselectall-v"] .btn').addClass('btn-secondary');

    product_bundles.each(function(i) {
      var _this = $(this),
          _l = $('.product-bundle-v2-container', _this).length;

      $('.product-bundle-v2-container', _this).each(function() {        
        var _this2 = $(this);
        var handle = _this2.data('product'),
            variants = _this2.data('variants') || '',
            quantity = parseInt(_this2.data('quantity')) || 1,
            title = _this2.data('title') || '',
            title_prefix = _this2.data('title-prefix') || '',
            title_suffix = _this2.data('title-suffix') || '';

        $.get(`${Shopify.routes.root}products/${handle}?view=api-html-multiselectall-v2`, function(product_html) {
          if (product_html.indexOf('<html') >= 0) return;
          
          var string_id = Math.random().toString(36).substring(2,7);
          product_html = product_html.replaceAll('[string_id]', string_id);
          _this2.html(product_html);

          if (variants != '') {
            variants = variants.split(',');
            var option_skus = [];
            $('select[name="id"] option', _this2).each(function() {
              var option_sku = $(this).attr('data-sku');
              if (variants.indexOf(option_sku) < 0) {
                option_skus.push(option_sku);
              }
            });
            $.each(option_skus, function(i, variant) {
              $(`select[name="id"] option[data-sku="${variant}"]`, _this2).remove();
            });
          }

          if (quantity > 1) {
            $(`input[name="quantity"]`, _this2).val(quantity);
          }

          if (title != '') {
            $(`.product-bundle-v2-title a`, _this2).text(title);
          } else {
            if (title_prefix != '') {
              $(`.product-bundle-v2-title a`, _this2).prepend(title_prefix+' ');
            }
            if (title_suffix != '') {
              $(`.product-bundle-v2-title a`, _this2).append(' '+title_suffix);
            }
          }

          var href = $(`.product-variants-dropdown select option:selected`, _this2).attr('data-url');
          $(`.product-bundle-v2-title a`, _this2).attr('href', href);

          _l--;
          if (_l == 0) loadBundleCombo(i, _this);
        });
      });

      _this.addClass('active');
      
      $('.offer-btn-add-to-cart', _this).removeAttr('disabled').removeClass('disabled');
    });

    function loadBundleCombo(idx, _this) {
      var swatch_dom = $('.product-bundle-v2-swatch-container', _this),
          has_checked = false;

      swatch_dom.addClass('product-swatch-radio');

      $('.swatch-element', swatch_dom).each(function(i) {
        var _this2 = $(this),
            color = _this2.data('color'),
            color_class = _this2.data('color-class').trim()
              .toLowerCase()
              .replace(/<[^>]*>?/gm, ' ')
              .replace(/[^\w ]+/g, ' ')
              .replace(/ +/g, '-'),
            image = _this2.data('image'),
            skus = _this2.data('skus'),
            soldout = false;
        
        $.each(skus.split(','), function(i, sku) {
          sku = sku.trim();
          var opt = $('option[data-sku="'+sku+'"]', _this);
  
          if (opt.length == 0) {
            return true;
          } else if (opt.attr('data-available') === 'false') {
            _this2.addClass('soldout');
            soldout = true;
          };
        })

        _this2.addClass(color_class).html(`<div class="tooltip">${color}</div>
          <input id="swatch-${idx}${i}-${color_class}" type="radio" name="option${idx}" value="${color}"
            data-image="${image}"
            data-skus="${skus}" />
          <label for="swatch-${idx}${i}-${color_class}" class="color-${color_class}"></label>`);

        if (!soldout && !has_checked) {
          $('input', _this2).attr('checked', 'checked').trigger('change');
          has_checked = true;
        }
      });
      if (!has_checked) {
        $('.swatch-element:first-child input', swatch_dom).trigger('change');
      }
    }

    // product_bundles.on('click', function(e) {
    //   if ($(e.target).closest('.product-swatch-dropdown').length == 0 && $('.product-swatch-dropdown.active').length > 0) {
    //     $('.product-swatch-dropdown').removeClass('active');
    //   }
    // });
    // product_bundles.on('click', '.product-swatch-dropdown', function(e) {
    //   $(this).toggleClass('active');
    // });
    // product_bundles.on('change', '.product-swatch-dropdown input', updateVariant);
    // product_bundles.on('change', '.product-swatch-dropdown input', function() {
    //   var dropdown = $(this).parents('.product-swatch-dropdown');
    //   $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
    //   dropdown.removeClass('active');
    // });

    product_bundles.on('change', '.product-swatch-radio input', updateVariant);

    function updateVariant() {
      var _this = $(this),
          image = _this.data('image'),
          skus = _this.data('skus');
      // bundle level
      var bundle = _this.parents('div[class*="product-bundle-multiselectall"]');

      // image
      $('.product-bundle-v2-image-box img', bundle).attr('src', image);

      // selection
      var available = 'true';
      $.each(skus.split(','), function(i, sku) {
        sku = sku.trim();
        var opt = $('option[data-sku="'+sku+'"]', bundle);

        if (opt.length == 0) {
          return true;
        }
        
        var val = opt.attr('value');
        opt.parent().val(val);

        available = available == 'true' ? opt.attr('data-available') : available;

        // product note
        var note = opt.attr('data-note'),
            div = opt.parents('.product-bundle-v2-variants'),
            cls = 'product-bundle-v2-product-note';
        $(`span.${cls}`, div).remove();
        if (note != '') {
          var span = document.createElement('span');
          span.classList.add(cls);
          span.innerHTML = note;
          div.append(span);
        }
        
        // product url
        var href = opt.attr('data-url');
        div.prev(`.product-bundle-v2-title`).find('a').attr('href', href);
      });


      if (available == 'false') {
        $('.offer-btn-add-to-cart', bundle)
          .attr('disabled', 'disabled')
          .addClass('disabled');
        $('.offer-btn-add-to-cart span', bundle).text(window.kef.latest_offer_texts.sold_out);
      } else {
        $('.offer-btn-add-to-cart', bundle)
          .removeAttr('disabled')
          .removeClass('disabled');
        $('.offer-btn-add-to-cart span.show-dt', bundle).text(window.kef.latest_offer_texts.add_to_cart);
        $('.offer-btn-add-to-cart span.show-mb', bundle).text(window.kef.latest_offer_texts.add_to_cart_mb);
      }
    }

    product_bundles.on('click', '.offer-btn-add-to-cart:not(.disabled)', function() {
      var _t = $(this);
      var data = {
        items: []
      };
      var bundle = $(this).parents('div[class*="product-bundle-multiselectall"]');
      $('.product-variants-dropdown select', bundle).each(function(i) {
        var id = $(this).val();
        var qty = $(this).parents('.product-variants-dropdown').next('input[name="quantity"]').val() || 1;
        var data_item = {
          quantity: qty,
          id: id,
          properties: {}
        }
        var option = $('option[value="'+id+'"]', this);
        var note = option.attr('data-note') || '';
        if (note != '') {
          data_item.properties.note = $(`<div>${note}</div>`).text();
        }
        data.items.push(data_item)
      });

      // product bundle
      var bundle_name = (_t.attr('data-bundle_name') || '').trim();
      if (bundle_name == '') {
        bundle_name = (_t.find('span[data-bundle_name]').attr('data-bundle_name') || '').trim();
      }
      // product bundle

      cart_fn.add(data).done(function(cart) {
        var quantity = data.items.map(function(item, key) {
          return item.quantity;
        });
        $('body').trigger({
          type: 'add_to_cart',
          quantity: quantity,
          cart: cart,
          bundle_name: bundle_name,
        });
      }).fail(function() {
      }).always(function() {
      });
    });
  }
}
latest_offer_v2.init();
latest_offer_v2.initMultiselectall();